/**
 * Gemeinsame Bausteine für die Rezeptliste und das Filterfenster.
 */

/** Ein Schnellfilter als Chip. */
export function QuickChip({
  label,
  active,
  onClick,
}: {
  readonly label: string;
  readonly active: boolean;
  readonly onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`shrink-0 rounded-full border px-3 py-1.5 text-sm transition-colors ${
        active
          ? 'border-accent bg-accent text-on-accent'
          : 'border-border-subtle bg-surface-raised text-content-muted hover:text-content'
      }`}
    >
      {label}
    </button>
  );
}

/** Ein entfernbarer Filterhinweis. */
export function FilterChip({ label, onRemove }: { readonly label: string; readonly onRemove: () => void }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-accent-soft px-2 py-0.5 text-xs text-accent-strong">
      {label}
      <button type="button" onClick={onRemove} aria-label={`${label} entfernen`}>
        ×
      </button>
    </span>
  );
}

/** Deutsche Bezeichnung eines Schwierigkeitsgrades. */
export function difficultyLabel(difficulty: 'easy' | 'medium' | 'hard'): string {
  return difficulty === 'easy' ? 'Leicht' : difficulty === 'medium' ? 'Mittel' : 'Schwer';
}
